import React from "react";

function InventoryScanTableHeader() {

    return (
        <div className="network-scan-table-header-v2">
            <div>
                <h2 className="network-scan-title-v2">Network Inventory</h2>
                <p className="network-scan-subtitle-v2">Discovered hosts and their latest scan details</p>
            </div>
        </div>
    );
}

export default InventoryScanTableHeader;
